/**
 * "Revisa tu correo" (Alta.dc.html, pantalla 2).
 *
 * Post-registro. Con reenvío (el backend responde siempre igual) y las dos
 * salidas honestas: spam y kakuat@kakuat.com.
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { resendVerification, apiMessage } from '../../services/apiClient';
import { Icon } from '../ui/Icon';
import { AuthLayout, MessageCard, PENDING_EMAIL_KEY } from './AuthLayout';

export function RevisaPage() {
  const email = sessionStorage.getItem(PENDING_EMAIL_KEY);
  const [resent, setResent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resend = async () => {
    if (!email || busy) return;
    setBusy(true);
    setError(null);
    try {
      await resendVerification(email);
      setResent(true);
    } catch (err: unknown) {
      // Sin catch, un fallo de red dejaba el botón habilitado y ningún
      // mensaje: silencio absoluto sobre un reenvío que no salió — el patrón
      // cuyo propio bug-doc dice "el silencio ES el bug" (ronda 3, r2b19).
      setError(apiMessage(err, 'No se pudo reenviar. Comprueba tu conexión e inténtalo de nuevo.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout>
      <MessageCard
        icon="mail"
        title="Revisa tu correo"
        body="Te hemos enviado un enlace para confirmar tu cuenta. Ábrelo y ya está: caduca en 24 horas."
      >
        <div className="bg-surface border border-line rounded-2xl px-5 py-4.5 text-left mb-6">
          <div className="font-mono text-[11px] tracking-[.08em] uppercase text-ink-3 mb-3">
            ¿No te llega?
          </div>
          <div className="flex gap-3 items-start mb-3">
            <Icon name="mail" size={19} strokeWidth={1.8} className="flex-none mt-px text-ink-2" />
            <span className="text-[14.5px] text-ink-2">Mira en spam o correo no deseado. A veces se cuela ahí.</span>
          </div>
          <div className="flex gap-3 items-start">
            <Icon name="clipboard" size={19} strokeWidth={1.8} className="flex-none mt-px text-ink-2" />
            <span className="text-[14.5px] text-ink-2">
              Sigue sin aparecer: escríbenos a{' '}
              <a href="mailto:kakuat@kakuat.com" className="text-brand font-semibold no-underline">kakuat@kakuat.com</a>.
            </span>
          </div>
        </div>

        {email ? (
          <>
            <button onClick={resend} disabled={busy} className="btn-ghost">
              {resent ? 'Correo reenviado ✓' : busy ? 'Reenviando…' : 'Reenviar correo'}
            </button>
            {error && (
              <p className="rounded-xl bg-danger-soft text-danger px-4 py-3 text-[14px] mt-3">
                {error}
              </p>
            )}
            <p className="text-[13px] text-ink-3 mt-4">
              Enviado a <strong className="text-ink-2">{email}</strong>
            </p>
          </>
        ) : (
          <p className="text-[14px] text-ink-2">
            ¿Vienes de otro dispositivo?{' '}
            <Link to="/login" className="text-brand font-semibold no-underline">Inicia sesión</Link> cuando hayas confirmado.
          </p>
        )}
      </MessageCard>
    </AuthLayout>
  );
}
